<template>
  <div class="collapse-text">
    <a v-b-toggle="`collapse-text-${self_id}`" href="javascript:void(0);" :class="textClasses">
      {{ text }}
      <i class="collapse-text-status la" :class="[ expanded_state === true ? `la-angle-down` : `la-angle-right` ]" />
    </a>
    <b-collapse :id="`collapse-text-${self_id}`" v-model="expanded_state"
                :class="{
                  'collapse-text-expanded': expanded_state,
                  'indent-content': indentContent,
                }"
                class="text-collapse"
                :visible="expanded"
                :accordion="accordion">
      <slot />
    </b-collapse>
  </div>
</template>

<script>
import { BCollapse, VBToggle } from 'bootstrap-vue';

let id_index = 0;
export default {
  components: {
    BCollapse,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    indentContent: {
      type: Boolean,
      required: false,
      default: true,
    },
    text: {
      type: String,
      required: true,
    },
    textClasses: {
      type: String,
      required: false,
      default: '',
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    accordion: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    self_id: null,
    expanded_state: false,
  }),
  beforeMount() {
    this.self_id = id_index;
    id_index += 1;
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "AssetsSass/_variables" as *;

.collapse-text {

  .indent-content {
    padding-left: 0.5em;
    border-left: 1px solid map.get($ss, 'secondary');
  }

  .collapse-text-status {
    font-size: 0.8em;
    margin-left: 0.5em;
  }
}
</style>
